import React, { useEffect } from 'react';
import Button from '../components/Button';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ProfileInformationForm from 'components/Profile/ProfileInformationForm';
import Navbar from 'components/Header/Navbar';
import ProfileCard from 'components/Profile/ProfileCard';
import Footer from 'components/Footer';
import SbPageHeader from 'components/layout/SbPageHeader';

const Profil: React.FC = () => {
  useEffect(() => {
    if (window.location.hash === '#profile-contact-edit') {
      document.getElementById('profile-contact-edit')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  // Initialize Bootstrap dropdown functionality
  // useEffect(() => {
  //   // Check if the bootstrap object is available
  //   if (typeof document !== 'undefined') {
  //     // This will run after the component mounts and the DOM is available
  //     const dropdownElementList = document.querySelectorAll('.dropdown-toggle');

  //     // Initialize each dropdown
  //     dropdownElementList.forEach(dropdownToggleEl => {
  //       // Make sure click events work properly
  //       dropdownToggleEl.addEventListener('click', function (e) {
  //         e.stopPropagation();
  //       });
  //     });
  //   }
  // }, []);

  return (
    <div className="min-vh-100" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
      {/* Header */}
      <Navbar />

      <main className="sb-page-container py-4 sb-page-shell">
        <SbPageHeader
          title="Profilim"
          subtitle="Hesap bilgilerinizi ve gizlilik tercihlerinizi yönetin."
          backTo={{ to: '/', label: 'İlanlara dön' }}
        />
        <div className="row sb-layout-row">
          <ProfileCard />

          <div className="col-md-8 min-w-0">

            <ProfileInformationForm />

            {/* İki Faktörlü Doğrulama */}
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-4">İki Faktörlü Doğrulama</h5>
                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    id="twoFactorAuth"
                    type="checkbox"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="twoFactorAuth"
                  >
                    SMS ile İki Faktörlü Doğrulamayı Etkinleştir
                  </label>
                </div>
                <div className="alert alert-info">
                  <i className="fas fa-info-circle me-2"></i>
                  SMS ile iki faktörlü doğrulama, hesabınıza her giriş yaptığınızda cep telefonunuza bir doğrulama kodu gönderilmesini sağlar. Bu kod olmadan hesabınıza erişim sağlanamaz ve hesap güvenliğiniz en üst düzeye çıkar. Aktifleştirmek için geçerli bir cep telefonu numarası eklemeniz gerekmektedir.
                </div>
                <div className="mt-3">
                  <Button className="btn btn-outline-primary" type="button">
                    <i className="fas fa-mobile-alt me-2"></i>
                    Doğrulama Kodunu Gönder
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* CSS ekleyelim */}
      <style>
        {`
        .product-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .product-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }
        
        /* Dropdown Styles */
        .dropdown-menu {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
            animation: fadeIn 0.3s ease;
        }

        .dropdown-header {
            font-weight: 600;
            letter-spacing: 0.5px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .dropdown-item {
            padding: 0.6rem 1.2rem;
            transition: all 0.2s;
        }

        .dropdown-item:hover {
            background-color: #f0f7ff;
            padding-left: 1.5rem;
        }

        .dropdown-item:active {
            background-color: #0d6efd;
            color: white;
        }

        .dropdown-item:active i {
            color: white !important;
        }

        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
        }

        /* Navbar Styles */
        .btn-link {
            text-decoration: none !important;
            box-shadow: none !important;
            border: none !important;
            outline: none !important;
        }

        .btn-link:focus, .btn-link:hover, .btn-link:active {
            text-decoration: none !important;
            box-shadow: none !important;
            border: none !important;
            outline: none !important;
        }

        .dropdown-toggle::after {
            vertical-align: middle;
            margin-left: 0.4em;
        }

        /* Profile Photo Styles */
        .profile-photo {
            position: relative;
            display: inline-block;
        }
        
        .photo-edit-icon {
            position: absolute;
            bottom: 0;
            right: 10px;
            background: #0d6efd;
            color: white;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s;
        }
        
        .photo-edit-icon:hover {
            background: #0b5ed7;
            transform: scale(1.1);
        }
        `}
      </style>

      <Footer />
    </div>
  );
};

export default Profil;
